import { render, staticRenderFns } from "./ENotaInput.vue?vue&type=template&id=dfa52272&scoped=true"
import script from "./ENotaInput.vue?vue&type=script&lang=js"
export * from "./ENotaInput.vue?vue&type=script&lang=js"
import style0 from "./ENotaInput.vue?vue&type=style&index=0&id=dfa52272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa52272",
  null
  
)

export default component.exports